module.exports = __webpack_public_path__ + "resources/img/solution_game_infra.d07cd5f5cfa931cc85d3ab8a0f2f1bf3.png";